import React from "react";
import PhoneInput from "react-phone-input-2";
import { styled } from "@mui/system";
import "react-phone-input-2/lib/style.css";

const StyledPhoneNumberInput = styled("div")(({ theme }) => ({
  width: "80%",
  maxWidth: "400px",
  margin: "10px auto",
  "& .react-tel-input": {
    width: "80%",
  },
  "@media (max-width: 600px)": {
    maxWidth: "80%",
    padding: "0 10px",
  },
}));

const PhoneNumberInput = ({
  value,
  onChange,
  country = "in",
  onlyCountries,
  placeholder,
  ...rest
}) => {
  const handleChange = (value, countryData) => {
    onChange(value, countryData.dialCode);
  };

  return (
    <StyledPhoneNumberInput>
      <PhoneInput
        country={country}
        value={value}
        onChange={handleChange}
        onlyCountries={onlyCountries}
        containerStyle={{ width: "100%" }}
        inputStyle={{ width: "100%" }}
        placeholder={placeholder}
        {...rest}
      />
    </StyledPhoneNumberInput>
  );
};

export default PhoneNumberInput;